import { enums } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';
import Global from '../../../global';

export default () => {
  const isUKClientEnabled = Global.config.enableUKClient;
  const { eMarkets } = enums;

  let marketsConfig = {
    83: eMarkets.SH,
    84: eMarkets.DE,
    /* Possible configuration
    1: {
       [eMarkets.RU]: ["BGR", "BLR", "HRV"]
     },
     */
    'others': {
      [eMarkets.RU]: ['BGR', 'BLR', 'HRV', 'CZE', 'EST', 'HUN', 'LVA', 'LTU', 'RUS', 'SRB', 'SVK', 'SVN', 'TUN', 'UKR', 'KAZ', 'UZB', 'AZE', 'ARM', 'GEO'],
      [eMarkets.ES]: ['ARG', 'BRA', 'CHL', 'MEX', 'ESP', 'BOL', 'COL', 'CRI', 'ECU', 'URY', 'GTM', 'PAN', 'PRY', 'PER', 'AND'],
      [eMarkets.IT]: ['MLT', 'SMR', 'VAT', 'ITA'],
      [eMarkets.DE]: ['AUT', 'DEU', 'CHE'],
      [eMarkets.RO]: ['ROU', 'MDA'],
      [eMarkets.PT]: ['PRT'],
      [eMarkets.DK]: ['DNK'],
      [eMarkets.FI]: ['FIN'],
      [eMarkets.FR]: ['FRA'],
      [eMarkets.NO]: ['NOR'],
      [eMarkets.PL]: ['POL'],
      [eMarkets.SE]: ['SWE'],
      [eMarkets.CA]: ['CAN'],
    },
    'default': eMarkets.ZZ,
  };

  if (isUKClientEnabled) {
    marketsConfig['others'][eMarkets.GB] = ['LKA', 'CYP', 'IND', 'JEY', 'ARE', 'TTO', 'SGP', 'NGA', 'NER', 'NZL', 'GGY', 'IMN'];
    marketsConfig['others'][eMarkets.UK] = ['GBR', 'IRL'];
  } else {
    marketsConfig['others'][eMarkets.GB] = ['GBR', 'IRL', 'LKA', 'CYP', 'IND', 'JEY', 'ARE', 'TTO', 'SGP', 'NGA', 'NER', 'NZL', 'GGY', 'IMN'];
  }

  return marketsConfig;
};
